export enum StatusLevel {
  Unavailable,
  AllSystemsOperational,
  MinorOutage,
  MajorOutage,
}
